// Module
var code = "<div class=\"configuration-shell\">\n  <configuration-navigation\n    organization-name=\"vm.organizationName\"\n  ></configuration-navigation>\n  <div class=\"configuration-workspace\" ui-view=\"\"></div>\n</div>\n";
// Exports
module.exports = code;